import { render } from "./VariantGroups.vue?vue&type=template&id=62a5880e"
import script from "./VariantGroups.vue?vue&type=script&lang=js"
export * from "./VariantGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/VariantGroups/VariantGroups.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62a5880e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62a5880e', __exports__)) {
    api.reload('62a5880e', __exports__)
  }
  
  module.hot.accept("./VariantGroups.vue?vue&type=template&id=62a5880e", () => {
    api.rerender('62a5880e', render)
  })

}


export default __exports__